import { render, staticRenderFns } from "./Modal-Budget.vue?vue&type=template&id=18b8e772&scoped=true&"
import script from "./Modal-Budget.vue?vue&type=script&lang=js&"
export * from "./Modal-Budget.vue?vue&type=script&lang=js&"
import style0 from "./Modal-Budget.vue?vue&type=style&index=0&id=18b8e772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8e772",
  null
  
)

export default component.exports